import { getFormattedDate } from 'legacy/hpscoutso/components/pages/amsEligibilityPartnersSearch/components/restriction/components/restrictionTooltipContent/helpers/getFormattedDate'

import { IColumn } from 'core-components/library/list/types'
import { APLAMSTranslationCodes } from 'onboarding/configs/translations/aplAMSTranslationCodes'
import { ITranslationFunction } from 'onboarding/context/LanguageContext'

import { IAmsSearchResponse } from '../models/iAmsSearchResponse'

import styles from './getTableColumns.module.scss'

export const getTableColumns = (t: ITranslationFunction): IColumn<IAmsSearchResponse>[] => {
  return [
    {
      title: 'Date',
      field: 'reportDate',
      hideSettings: true,
      disableSort: true,
    },
    {
      title: 'Parent / Location ID',
      field: 'locationID',
      hideSettings: true,
      disableSort: true,
      renderFunction: (item) => {
        return (
          <div>
            {item.parentLocationID !== item.locationID
              ? `${item.parentLocationID} / ${item.locationID}`
              : item.locationID}
          </div>
        )
      },
    },
    {
      title: 'Account',
      field: 'account',
      hideSettings: true,
      disableSort: true,
    },
    {
      title: 'HQ',
      field: 'isHQ',
      hideSettings: true,
      disableSort: true,
      renderFunction: (item) => {
        return <div>{item.isHQ ? 'Y' : 'N'}</div>
      },
    },
    {
      title: 'DBA',
      field: 'dba',
      hideSettings: true,
      disableSort: true,
    },
    {
      title: 'Address',
      field: 'address',
      hideSettings: true,
      disableSort: true,
      renderFunction: (item) => {
        return (
          <div className={styles.oneLine}>
            <div>
              {item.address}
              {item.city ? ',' : ''}
            </div>
            <div>
              {item.city}, {item.state}
              {item.country ? ',' : ''}
            </div>
            <div>{item.country}</div>
          </div>
        )
      },
    },
    {
      title: t(APLAMSTranslationCodes.print_hw_column),
      field: 'printHW',
      hideSettings: true,
      disableSort: true,
      renderFunction: (item) => {
        return <div>{item.printHW ? 'Y' : 'N'}</div>
      },
    },
    {
      title: t(APLAMSTranslationCodes.supplies_column),
      field: 'supplies',
      hideSettings: true,
      disableSort: true,
      renderFunction: (item) => {
        return <div>{item.supplies ? 'Y' : 'N'}</div>
      },
    },
    {
      title: t(APLAMSTranslationCodes.bps_column),
      field: 'bps',
      hideSettings: true,
      disableSort: true,
      renderFunction: (item) => {
        return <div>{item.bps ? 'Y' : 'N'}</div>
      },
    },
    {
      title: t(APLAMSTranslationCodes.cps_column),
      field: 'cps',
      hideSettings: true,
      disableSort: true,
      renderFunction: (item) => {
        return <div>{item.cps ? 'Y' : 'N'}</div>
      },
    },
    {
      title: 'PA Start',
      field: 'paStart',
      hideSettings: true,
      disableSort: true,
    },
    {
      title: 'Agreement',
      field: 'agreement',
      hideSettings: true,
      disableSort: true,
    },
    {
      title: 'Supplies Special Pricing Eligibility',
      field: 'suppliesSpecialPricingEligibility',
      hideSettings: true,
      disableSort: true,
      renderFunction: (item) => {
        return <div>{item.suppliesSpecialPricingEligibility ? 'Y' : 'N'}</div>
      },
    },
    {
      title: 'Print & Supplies Drop Ship Model',
      field: 'printSuppliesDropShipModel',
      hideSettings: true,
      disableSort: true,
      renderFunction: (item) => {
        return <div>{item.printSuppliesDropShipModel ? 'Y' : 'N'}</div>
      },
    },
    {
      title: 'DesignJet Online',
      field: 'designJetOnline',
      hideSettings: true,
      disableSort: true,
    },
    {
      title: 'Supplies Stocking Exception',
      field: 'suppliesStockingException',
      hideSettings: true,
      disableSort: true,
    },
    {
      title: 'Amplify Membership',
      field: 'amplifyMembership',
      hideSettings: true,
      disableSort: true,
    },
    {
      title: t(APLAMSTranslationCodes.restrictions_column),
      field: 'restrictions',
      hideSettings: true,
      disableSort: true,
      renderFunction: (item) => {
        return tableRestrictions(item)
      },
    },
  ]
}

const tableRestrictions = (item: IAmsSearchResponse) => {
  if (!item.restrictions.length) {
    return <div />
  }

  return (
    <table className={styles.lightweightTable}>
      <thead>
        <tr>
          <th>Category</th>
          <th>Suspend</th>
          <th>PLs</th>
          <th>From</th>
          <th>To</th>
        </tr>
      </thead>
      {item.restrictions.map((restriction) => {
        let from = ''
        let to = ''
        try {
          from = getFormattedDate(new Date(restriction.startDate))
        } catch (e) {
          console.error(e)
        }

        try {
          to = getFormattedDate(new Date(restriction.endDate))
        } catch (e) {
          console.error(e)
        }

        return (
          <tr key={`${restriction.category}_${restriction.suspend}`}>
            <td>{restriction.category}</td>
            <td>{restriction.suspend}</td>
            <td>{restriction.pl.join(', ')}</td>
            <td>{from}</td>
            <td>{to}</td>
          </tr>
        )
      })}
    </table>
  )
}
